import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { Row, Col, Form, Button } from 'react-bootstrap';

import PageTitle from '../../../common/PageTitle';

import BandField from './BandField';
import { fetchBands } from '../../../store/actions/bands/bandActions';
import { handleInputChange, 
  fetchPlatformBands, 
  createPlatform, 
  resetPlatform, 
  getPlatform, 
  updatePlatform,
  handleBandCostChange } from '../../../store/actions/platforms/platformActions';
import { PORTAL_ADMIN, FINANCE_APPROVER } from '../../../store/actions/users/usersActions';
import Select from 'react-select';
import moment from 'moment';

class PlatformForm extends Component {

  constructor(props) {
    super(props);
    
    this.action = '';
    this.platform = '';
    this.submitButtonText = '';
    this.pageTitle = '';
  }
  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === FINANCE_APPROVER) {
      this.props.fetchBands();
      this.submitButtonText = 'Submit';
      this.action = 'ADD_PLATFORM';

      const pathname = this.props.location.pathname;
      if (pathname === '/settings/platforms/update' || pathname === '/settings/platforms/view') {
        const urlParams = new URLSearchParams(this.props.location.search);
        const platformId =  urlParams.get('id');
        this.props.getPlatform(platformId);
        this.submitButtonText = 'Update';
        this.action = 'UPDATE_PLATFORM';
        this.pageTitle = 'Update Platform';
      }
      else {
        this.pageTitle = 'Add Platform';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.resetPlatform();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitting...";
    }
    else {
      submitButton.textContent = "Updating...";
    } 

    if (this.action === 'ADD_PLATFORM') {
      this.props.createPlatform(() => {
        this.props.history.push('/settings/platforms');
        submitButton.disabled = false;
        submitButton.textContent = "Submitted!";
      });
    }
    else {
      this.props.updatePlatform(() => {
        this.props.history.push('/settings/platforms');
        submitButton.disabled = false;
        submitButton.textContent = "Updated!";
      });
    }
  }

  displayPlatformFields = () => {
    let platformName = '';
    let chargeability = '';
    let yearValueIndex = '';

    let years = [];

    for (let y = 0; y < 10; y++) {
      const year = moment().year() - y;
      years.push({
        label: year, 
        value: year
      });
    }

    const platform = this.props.platforms.platform;

    if (this.action === 'UPDATE_PLATFORM') {
      if (Object.keys(this.props.platforms.platform).length) {
        if (platform) {
          platformName = platform.platform_name;
          chargeability = platform.chargeability;
        }
      }
    }

    const selectedYear = platform.year !== "undefined" ? platform.year : '';

    years.forEach((year, index) => {
      if (year.value === selectedYear) {
        yearValueIndex = index;
      }
    })
 
    return (
      <Row className="mt-3">
        <Col>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="platform_name">
                <Form.Label>Platform Name<span className='required-field'> * </span></Form.Label>
                  <Form.Control 
                    type="text" 
                    defaultValue={platformName} 
                    readOnly={!!this.props.viewOnly}
                    onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="chargeability">
                <Form.Label>Chargeability<span className='required-field'> * </span></Form.Label>
                  <Form.Control 
                    type="number" 
                    step="0.01" 
                    readOnly={!!this.props.viewOnly} 
                    defaultValue={chargeability} 
                    onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="year">
                <Form.Label>Year<span className='required-field'> * </span></Form.Label>
                <Select 
                  isSearchable={true}
                  name="year"  
                  id="year" 
                  isMulti={false} 
                  value={years[yearValueIndex]} 
                  options={years} 
                  onChange={(value) => {
                    if (typeof(platform.id) !== "undefined") {
                      this.props.fetchPlatformBands({platform_id: platform.id, year: value.value});
                    }
                    this.props.handleInputChange(null, {'year': value.value})
                  }} />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  displayBands = () => {
    const bands = this.props.bands.bands;
    let arrPlatformBands = [];

    if (this.action === 'UPDATE_PLATFORM') {
      let platformBands = this.props.platforms.arrPlatformBands;

      platformBands && platformBands.length && platformBands.forEach(platformBand => {
        arrPlatformBands.push({
          band_id: platformBand.band_id, 
          cost: platformBand.cost, 
          fullyLoaded: platformBand.fully_loaded 
        })
      })
    }

    const bandFields = bands.length ? (
      bands.map((band, key) => {
        //check if platform objects are set. Means we're editing.
        let fullyLoadedCost = null;
        let unloadedCost = null;
        if (this.action === 'UPDATE_PLATFORM') {
          arrPlatformBands.filter(data => {
            if (parseInt(data.band_id) === band.id) {
              return data;
            }
            return false;
          }).forEach(platformBand => {
            if (platformBand.fullyLoaded) {
              fullyLoadedCost = platformBand.cost;
            }
            else {
              unloadedCost = platformBand.cost;
            }
          })  
        }

        return (
          <BandField 
            key={key} 
            band={band}
            fullyLoadedCost={fullyLoadedCost}  
            unloadedCost={unloadedCost} 
            viewOnly={this.props.viewOnly} 
            onInputChange={(e, costingType) => this.props.handleBandCostChange(e, costingType)} />
        )
      })
    ) : (
      <Row>
        <Col>Loading...</Col>
      </Row>
    ) 
    
    return (
      <>
        <Row className="mt-3 mb-3">
          <Col xs={1} sm={1} md={1} lg={1} xl={1} className="align-center">Bands</Col>
          <Col xs={3} sm={3} md={3} lg={3} xl={3} className="align-center">Fully Loaded Cost</Col>
          <Col xs={3} sm={3} md={3} lg={3} xl={3} className="align-center">Unloaded Cost</Col>
        </Row>
        {bandFields}
      </>
    )
  }

  render() {
    this.platform = this.props.platforms.platform;
    return (
      <>
        <PageTitle pageName={this.pageTitle} />
        <Form onSubmit={this.handleSubmit}>
          { this.displayPlatformFields() }
          { this.displayBands() }
          {!this.props.viewOnly && <Row>
            <Col xs={7} sm={7} md={7} lg={7} xl={7}>
              <div className="align-right">
                <Button variant="default" onClick={() => {
                    this.props.history.push('/settings/platforms');
                  }}>Cancel</Button> 
                <Button variant="primary" type="submit">{this.submitButtonText}</Button>
              </div>
            </Col>
          </Row>}
        </Form>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    platforms: state.platforms, 
    bands: state.bands 
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchBands: () => dispatch(fetchBands()),
  handleInputChange: (...args) => dispatch(handleInputChange(...args)),
  createPlatform: (...args) => dispatch(createPlatform(...args)), 
  updatePlatform: (...args) => dispatch(updatePlatform(...args)), 
  getPlatform: (...args) => dispatch(getPlatform(...args)),
  resetPlatform: () => dispatch(resetPlatform()),
  fetchPlatformBands: (...args) => dispatch(fetchPlatformBands(...args)),
  handleBandCostChange: (...args) => dispatch(handleBandCostChange(...args))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlatformForm))